import React from 'react' 

export const Form = ({children, ...props}) => {
    return ( 
        <form className='myForm' noValidate {...props}>{children}</form>
    )
}